module.exports = __webpack_public_path__ + "asset/image-ic_category_29-983f4151a36d1ff6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_29.svg
// module id = lAgd
// module chunks = 0